import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { MyExpensesRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import useLegalEntities from 'modules/expenses/hooks/useLegalEntities'
import { useTaxAgencyHomologations } from 'modules/expenses/hooks/useTaxAgencyHomologations'
import CollectionsBootstrap from 'modules/expenses/lib/My_expensesCollectionsBootstrap'
import { FrequencyContextProvider } from 'modules/payroll_bundle/lib/frequencyContext'

import { MyExpensesContextProvider } from './MyExpensesContext'

const Container = () => {
  const { navigation } = useNavigation()

  const { employee, company } = useCurrentSession()

  const back = {
    href: navigation.myExpenses.fullPath(),
  }

  const { data, error } = useQuery(MyExpensesRootPageDocument, {
    variables: {
      companyId: company.id,
      moduleId: AvailableModules.expenses,
      featureIds: [
        Features.expenses_reimburse_through_payroll,
        Features.expenses_reimburse_through_payments,
        Features.expenses_homologation,
        Features.expenses_report_on_behalf,
        Features.expenses_spending_policies,
        Features.expenses_per_diems,
        Features.projects_management,
      ],
    },
  })
  const signedDocumentsTerms = data?.expenses?.signedDocumentsTermsConnection?.nodes ?? []
  const expensesModuleEnabled =
    data?.companies?.moduleAvailabilitiesConnection?.nodes[0]?.available ?? false
  const taxAgencyHomologationEnabled =
    data?.companies.featureAvailabilities.find((f) => f.id === Features.expenses_homologation)
      ?.available ?? false
  const expensableGroupsEnabled =
    data?.expenses?.expensableGroupsSettingsConnection?.nodes[0]?.enabled ?? false

  const { legalEntities } = useLegalEntities()
  const legalEntityId = employee?.legalEntity?.id
  const signingLegalEntity = legalEntities.find((x) => x.id === legalEntityId)

  const { loading: loadingTaxAgencyHomologation, organizations: taxAgencyOrgs } =
    useTaxAgencyHomologations(signingLegalEntity ? [signingLegalEntity] : [])

  const organization = Object.values(taxAgencyOrgs).find((x) => x.applies)
  const signingOrganization =
    taxAgencyHomologationEnabled && organization?.applies ? organization.id : null

  const reimburseThroughPayrollEnabled =
    data?.companies.featureAvailabilities.find(
      (f) => f.id === Features.expenses_reimburse_through_payroll
    )?.available ?? false

  const reimburseThroughPaymentsEnabled =
    data?.companies.featureAvailabilities.find(
      (f) => f.id === Features.expenses_reimburse_through_payments
    )?.available ?? false

  const hasDocumentsTermsForOrganizationSigned =
    signedDocumentsTerms.filter((t) => t.organization == signingOrganization).length > 0

  const hasAccess = () => {
    return !!employee && expensesModuleEnabled
  }

  if (error) throw new Error('Error fetching data')
  if (!data || loadingTaxAgencyHomologation)
    return (
      <Box width="full" alignItems="center" padding="s48">
        <Spinner />
      </Box>
    )

  return (
    <AuthorizeUser authorizeFn={hasAccess}>
      <MyExpensesContextProvider data={data}>
        <FrequencyContextProvider>
          <Outlet
            context={{
              back,
              section: 'personal',
              taxAgencyOrganizationId: hasDocumentsTermsForOrganizationSigned
                ? signingOrganization
                : null,
              expensableGroupsEnabled: expensableGroupsEnabled,
              canSyncWithBanking: reimburseThroughPaymentsEnabled,
              canSyncWithPayroll: reimburseThroughPayrollEnabled,
            }}
          />
        </FrequencyContextProvider>
      </MyExpensesContextProvider>
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
